// extracted by mini-css-extract-plugin
module.exports = {"container":"StorageFileItem_container__1a-L3","name":"StorageFileItem_name__2VBX2","cancel":"StorageFileItem_cancel__1Shs-","error":"StorageFileItem_error__tvahY"};